import { cx } from '@twind/core';
import { useLanguages } from 'app/hooks/useOstroModules';
import { Outlet } from 'react-router-dom';
import { useTailorHalfOpen } from 'app/hooks/useTailorHalfOpen';
import { useContactFormState } from 'app/modules/contact-form/stores/useContactFormState';

import ContactForm from '../../modules/contact-form/ContactForm';
import TailorImportantInformation from '../../modules/tailor/components/TailorImportantInformation';
import ScreenAnimation from '../ScreenAnimation';
import { ToastProvider, useToast, ToastPosition } from '../../context/ToastContext';
import { ToastContainer } from '../Toast';

function RootLayoutContent({
  hideImportantInformation = false,
  stickyImportantInformation = false,
  hideContactForm = false,
}: {
  hideImportantInformation?: boolean;
  stickyImportantInformation?: boolean;
  hideContactForm?: boolean;
}) {
  const { isOpen } = useContactFormState();
  const { halfOpen } = useTailorHalfOpen();
  const { getToastsByPosition } = useToast();

  useLanguages();

  const toastsByPosition = getToastsByPosition();

  return (
    <ScreenAnimation>
      {!hideImportantInformation && !halfOpen && (
        <TailorImportantInformation className={cx('shrink-0', stickyImportantInformation ? 'sticky top-0' : '')} />
      )}
      <Outlet />
      {!hideContactForm && isOpen && <ContactForm />}
      {Object.entries(toastsByPosition).map(([position, toasts]) =>
        toasts.length > 0 ? (
          <ToastContainer
            key={position}
            toasts={toasts}
            position={position as ToastPosition}
          />
        ) : null
      )}
    </ScreenAnimation>
  );
}

export function RootLayout(props: {
  hideImportantInformation?: boolean;
  stickyImportantInformation?: boolean;
  hideContactForm?: boolean;
}) {
  return (
    <ToastProvider>
      <RootLayoutContent {...props} />
    </ToastProvider>
  );
}
